import { Link } from "react-router-dom";
import { NAV_LINKS, SITE, waLink } from "@/config/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function Footer() {
  return (
    <footer className="bg-[#141519] text-white/70" data-testid="footer">
      <div className="container-x grid gap-12 py-14 sm:py-16 lg:grid-cols-3">
        <div>
          <div className="inline-block rounded-2xl bg-white p-3">
            <img src="/logo.webp" alt="Farma Store — Parafarmacia e Servizi" className="h-9 w-auto" width="2000" height="343" />
          </div>
          <p className="mt-6 max-w-xs text-sm leading-relaxed">
            Parafarmacia e Servizi a {SITE.city}: dermocosmesi, benessere e consulenze professionali.
          </p>
        </div>

        <nav aria-label="Collegamenti footer">
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white">Esplora</h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <a href={l.href} data-testid={`footer-link-${l.id}`} className="text-sm transition-colors hover:text-white">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white">Contatti</h3>
          <address className="mt-5 space-y-3 text-sm not-italic leading-relaxed">
            <p>
              {SITE.name}
              <br />
              {SITE.address}
            </p>
            <p>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="inline-flex items-center gap-2 font-bold text-white transition-colors hover:text-[#25d366]"
              >
                <WhatsAppIcon className="h-4 w-4" />
                Scrivici su WhatsApp
              </a>
            </p>
          </address>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-xs text-white/45 sm:flex-row">
          <p>© {new Date().getFullYear()} {SITE.name} — {SITE.tagline}, {SITE.city} (FR)</p>
          <p>Farma Store è un marchio registrato di Nutralis S.r.l. · P.IVA 03300400607</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-white">
              Privacy e Cookie Policy
            </Link>
            <p>Parafarmacia · Dermocosmesi · Benessere</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
